module.exports = __webpack_public_path__ + "img/oldmail-02@2x.6e0199bd.png";